/* tslint:disable */
/* eslint-disable */
/**
 * DUPR Backend APIs (Internal)
 * Internal RESTful APIs to access DUPR ratings, users and provide matches.
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../../base';
// @ts-ignore
import type { ArrayWrapperLong } from '../../../commons/generated/model';
// @ts-ignore
import type { ArrayWrapperObject } from '../../../commons/generated/model';
// @ts-ignore
import type { ArrayWrapperScoreFormatResponse } from '../../../commons/generated/model';
// @ts-ignore
import type { BatchMatchAnnotationsRequest } from '../../../commons/generated/model';
// @ts-ignore
import type { MatchConfirmRequest } from '../../../commons/generated/model';
// @ts-ignore
import type { MatchForecastRequest } from '../../../commons/generated/model';
// @ts-ignore
import type { MatchForecastResponse } from '../../../commons/generated/model';
// @ts-ignore
import type { MatchRatingSimulatorRequest } from '../../../commons/generated/model';
// @ts-ignore
import type { MatchRequest } from '../../../commons/generated/model';
// @ts-ignore
import type { MatchSearchRequest } from '../../../commons/generated/model';
// @ts-ignore
import type { ShareMatchRequest } from '../../../commons/generated/model';
// @ts-ignore
import type { SingleWrapperLong } from '../../../commons/generated/model';
// @ts-ignore
import type { SingleWrapperPageTypedMatchResponse } from '../../../commons/generated/model';
// @ts-ignore
import type { SingleWrapperPostResponse } from '../../../commons/generated/model';
// @ts-ignore
import type { SingleWrapperTypedMatchResponse } from '../../../commons/generated/model';
// @ts-ignore
import type { UserActionRequiredResponse } from '../../../commons/generated/model';
// @ts-ignore
import type { VerifiedMatchRequest } from '../../../commons/generated/model';
// @ts-ignore
import type { Wrapper } from '../../../commons/generated/model';
/**
 * MatchesApi - axios parameter creator
 * @export
 */
export const MatchesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a sparse map keyed by obfuscated matchId. Matches with no active annotations are absent from the response. A match can carry annotations from multiple vendors — one entry per (match, clientKey) pair, with the obfuscated clientKeyId on each entry. Capped at 500 match IDs per request.
         * @summary Batch-fetch vendor annotations for a list of matches.
         * @param {string} version 
         * @param {BatchMatchAnnotationsRequest} batchMatchAnnotationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchAnnotations: async (version: string, batchMatchAnnotationsRequest: BatchMatchAnnotationsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('batchAnnotations', 'version', version)
            // verify required parameter 'batchMatchAnnotationsRequest' is not null or undefined
            assertParamExists('batchAnnotations', 'batchMatchAnnotationsRequest', batchMatchAnnotationsRequest)
            const localVarPath = `/match/{version}/annotations/batch`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchMatchAnnotationsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {MatchConfirmRequest} matchConfirmRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmMatch: async (version: string, matchConfirmRequest: MatchConfirmRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('confirmMatch', 'version', version)
            // verify required parameter 'matchConfirmRequest' is not null or undefined
            assertParamExists('confirmMatch', 'matchConfirmRequest', matchConfirmRequest)
            const localVarPath = `/match/{version}/confirm`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(matchConfirmRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMatch1: async (version: string, id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('deleteMatch1', 'version', version)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteMatch1', 'id', id)
            const localVarPath = `/match/{version}/delete/{id}`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDuprPerformanceData: async (version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('getDuprPerformanceData', 'version', version)
            const localVarPath = `/match/{version}/performance`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDuprPerformanceDataUser: async (version: string, id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('getDuprPerformanceDataUser', 'version', version)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDuprPerformanceDataUser', 'id', id)
            const localVarPath = `/match/{version}/performance/{id}`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {MatchForecastRequest} matchForecastRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMatchExpectedScore: async (version: string, matchForecastRequest: MatchForecastRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('getMatchExpectedScore', 'version', version)
            // verify required parameter 'matchForecastRequest' is not null or undefined
            assertParamExists('getMatchExpectedScore', 'matchForecastRequest', matchForecastRequest)
            const localVarPath = `/match/{version}/expected-score`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(matchForecastRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {MatchForecastRequest} matchForecastRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMatchForecast: async (version: string, matchForecastRequest: MatchForecastRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('getMatchForecast', 'version', version)
            // verify required parameter 'matchForecastRequest' is not null or undefined
            assertParamExists('getMatchForecast', 'matchForecastRequest', matchForecastRequest)
            const localVarPath = `/match/{version}/forecast`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(matchForecastRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {MatchRatingSimulatorRequest} matchRatingSimulatorRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMatchRatingSimulator: async (version: string, matchRatingSimulatorRequest: MatchRatingSimulatorRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('getMatchRatingSimulator', 'version', version)
            // verify required parameter 'matchRatingSimulatorRequest' is not null or undefined
            assertParamExists('getMatchRatingSimulator', 'matchRatingSimulatorRequest', matchRatingSimulatorRequest)
            const localVarPath = `/match/{version}/rating-simulator`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(matchRatingSimulatorRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated. Always returns 401 regardless of auth state. Originally surfaced for pre-signup claim flows but was never wired truly-public; admins/support should call /admin/users/{userId}/match-history instead.
         * @summary [DEPRECATED] Always 401 — use GET /admin/users/{userId}/match-history
         * @param {string} version 
         * @param {number} id 
         * @param {number} offset 
         * @param {number} limit 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getUserMatchHistory: async (version: string, id: number, offset: number, limit: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('getUserMatchHistory', 'version', version)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getUserMatchHistory', 'id', id)
            // verify required parameter 'offset' is not null or undefined
            assertParamExists('getUserMatchHistory', 'offset', offset)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getUserMatchHistory', 'limit', limit)
            const localVarPath = `/match/{version}/history/unauthenticated/{id}`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        matchDetails: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('matchDetails', 'id', id)
            const localVarPath = `/match/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pendingMatchDetails: async (version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('pendingMatchDetails', 'version', version)
            const localVarPath = `/match/{version}/pending`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {MatchRequest} matchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveMatch: async (version: string, matchRequest: MatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('saveMatch', 'version', version)
            // verify required parameter 'matchRequest' is not null or undefined
            assertParamExists('saveMatch', 'matchRequest', matchRequest)
            const localVarPath = `/match/{version}/save`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(matchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {VerifiedMatchRequest} verifiedMatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveVerifiedMatch: async (version: string, verifiedMatchRequest: VerifiedMatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('saveVerifiedMatch', 'version', version)
            // verify required parameter 'verifiedMatchRequest' is not null or undefined
            assertParamExists('saveVerifiedMatch', 'verifiedMatchRequest', verifiedMatchRequest)
            const localVarPath = `/match/verified/{version}/save`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifiedMatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {File} request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveVerifiedMatchCVS: async (version: string, request: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('saveVerifiedMatchCVS', 'version', version)
            // verify required parameter 'request' is not null or undefined
            assertParamExists('saveVerifiedMatchCVS', 'request', request)
            const localVarPath = `/match/verified/{version}/save/csv/add`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (request !== undefined) { 
                localVarFormParams.append('request', request as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scoreFormats: async (version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('scoreFormats', 'version', version)
            const localVarPath = `/match/{version}/score/formats`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {number} id 
         * @param {ShareMatchRequest} shareMatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareMatch: async (version: string, id: number, shareMatchRequest: ShareMatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('shareMatch', 'version', version)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('shareMatch', 'id', id)
            // verify required parameter 'shareMatchRequest' is not null or undefined
            assertParamExists('shareMatch', 'shareMatchRequest', shareMatchRequest)
            const localVarPath = `/match/{version}/share/{id}/newsfeed`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shareMatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {number} offset 
         * @param {number} limit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userMatchHistory: async (version: string, offset: number, limit: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('userMatchHistory', 'version', version)
            // verify required parameter 'offset' is not null or undefined
            assertParamExists('userMatchHistory', 'offset', offset)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('userMatchHistory', 'limit', limit)
            const localVarPath = `/match/{version}/history`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {MatchSearchRequest} matchSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userMatchHistoryByFilters: async (version: string, matchSearchRequest: MatchSearchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('userMatchHistoryByFilters', 'version', version)
            // verify required parameter 'matchSearchRequest' is not null or undefined
            assertParamExists('userMatchHistoryByFilters', 'matchSearchRequest', matchSearchRequest)
            const localVarPath = `/match/{version}/history`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(matchSearchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MatchesApi - functional programming interface
 * @export
 */
export const MatchesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MatchesApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns a sparse map keyed by obfuscated matchId. Matches with no active annotations are absent from the response. A match can carry annotations from multiple vendors — one entry per (match, clientKey) pair, with the obfuscated clientKeyId on each entry. Capped at 500 match IDs per request.
         * @summary Batch-fetch vendor annotations for a list of matches.
         * @param {string} version 
         * @param {BatchMatchAnnotationsRequest} batchMatchAnnotationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async batchAnnotations(version: string, batchMatchAnnotationsRequest: BatchMatchAnnotationsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.batchAnnotations(version, batchMatchAnnotationsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchesApi.batchAnnotations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {MatchConfirmRequest} matchConfirmRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmMatch(version: string, matchConfirmRequest: MatchConfirmRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Wrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmMatch(version, matchConfirmRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchesApi.confirmMatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMatch1(version: string, id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Wrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMatch1(version, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchesApi.deleteMatch1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDuprPerformanceData(version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArrayWrapperObject>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDuprPerformanceData(version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchesApi.getDuprPerformanceData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDuprPerformanceDataUser(version: string, id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArrayWrapperObject>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDuprPerformanceDataUser(version, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchesApi.getDuprPerformanceDataUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {MatchForecastRequest} matchForecastRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMatchExpectedScore(version: string, matchForecastRequest: MatchForecastRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MatchForecastResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMatchExpectedScore(version, matchForecastRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchesApi.getMatchExpectedScore']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {MatchForecastRequest} matchForecastRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMatchForecast(version: string, matchForecastRequest: MatchForecastRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MatchForecastResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMatchForecast(version, matchForecastRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchesApi.getMatchForecast']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {MatchRatingSimulatorRequest} matchRatingSimulatorRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMatchRatingSimulator(version: string, matchRatingSimulatorRequest: MatchRatingSimulatorRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMatchRatingSimulator(version, matchRatingSimulatorRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchesApi.getMatchRatingSimulator']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deprecated. Always returns 401 regardless of auth state. Originally surfaced for pre-signup claim flows but was never wired truly-public; admins/support should call /admin/users/{userId}/match-history instead.
         * @summary [DEPRECATED] Always 401 — use GET /admin/users/{userId}/match-history
         * @param {string} version 
         * @param {number} id 
         * @param {number} offset 
         * @param {number} limit 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getUserMatchHistory(version: string, id: number, offset: number, limit: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserMatchHistory(version, id, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchesApi.getUserMatchHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async matchDetails(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SingleWrapperTypedMatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.matchDetails(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchesApi.matchDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pendingMatchDetails(version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArrayWrapperLong>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pendingMatchDetails(version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchesApi.pendingMatchDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {MatchRequest} matchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveMatch(version: string, matchRequest: MatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SingleWrapperLong>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveMatch(version, matchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchesApi.saveMatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {VerifiedMatchRequest} verifiedMatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveVerifiedMatch(version: string, verifiedMatchRequest: VerifiedMatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Wrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveVerifiedMatch(version, verifiedMatchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchesApi.saveVerifiedMatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {File} request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveVerifiedMatchCVS(version: string, request: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Wrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveVerifiedMatchCVS(version, request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchesApi.saveVerifiedMatchCVS']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scoreFormats(version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArrayWrapperScoreFormatResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scoreFormats(version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchesApi.scoreFormats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {number} id 
         * @param {ShareMatchRequest} shareMatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shareMatch(version: string, id: number, shareMatchRequest: ShareMatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SingleWrapperPostResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shareMatch(version, id, shareMatchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchesApi.shareMatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {number} offset 
         * @param {number} limit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userMatchHistory(version: string, offset: number, limit: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SingleWrapperPageTypedMatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userMatchHistory(version, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchesApi.userMatchHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {MatchSearchRequest} matchSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userMatchHistoryByFilters(version: string, matchSearchRequest: MatchSearchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SingleWrapperPageTypedMatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userMatchHistoryByFilters(version, matchSearchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchesApi.userMatchHistoryByFilters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MatchesApi - factory interface
 * @export
 */
export const MatchesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MatchesApiFp(configuration)
    return {
        /**
         * Returns a sparse map keyed by obfuscated matchId. Matches with no active annotations are absent from the response. A match can carry annotations from multiple vendors — one entry per (match, clientKey) pair, with the obfuscated clientKeyId on each entry. Capped at 500 match IDs per request.
         * @summary Batch-fetch vendor annotations for a list of matches.
         * @param {string} version 
         * @param {BatchMatchAnnotationsRequest} batchMatchAnnotationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchAnnotations(version: string, batchMatchAnnotationsRequest: BatchMatchAnnotationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.batchAnnotations(version, batchMatchAnnotationsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {MatchConfirmRequest} matchConfirmRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmMatch(version: string, matchConfirmRequest: MatchConfirmRequest, options?: RawAxiosRequestConfig): AxiosPromise<Wrapper> {
            return localVarFp.confirmMatch(version, matchConfirmRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMatch1(version: string, id: number, options?: RawAxiosRequestConfig): AxiosPromise<Wrapper> {
            return localVarFp.deleteMatch1(version, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDuprPerformanceData(version: string, options?: RawAxiosRequestConfig): AxiosPromise<ArrayWrapperObject> {
            return localVarFp.getDuprPerformanceData(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDuprPerformanceDataUser(version: string, id: number, options?: RawAxiosRequestConfig): AxiosPromise<ArrayWrapperObject> {
            return localVarFp.getDuprPerformanceDataUser(version, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {MatchForecastRequest} matchForecastRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMatchExpectedScore(version: string, matchForecastRequest: MatchForecastRequest, options?: RawAxiosRequestConfig): AxiosPromise<MatchForecastResponse> {
            return localVarFp.getMatchExpectedScore(version, matchForecastRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {MatchForecastRequest} matchForecastRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMatchForecast(version: string, matchForecastRequest: MatchForecastRequest, options?: RawAxiosRequestConfig): AxiosPromise<MatchForecastResponse> {
            return localVarFp.getMatchForecast(version, matchForecastRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {MatchRatingSimulatorRequest} matchRatingSimulatorRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMatchRatingSimulator(version: string, matchRatingSimulatorRequest: MatchRatingSimulatorRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getMatchRatingSimulator(version, matchRatingSimulatorRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated. Always returns 401 regardless of auth state. Originally surfaced for pre-signup claim flows but was never wired truly-public; admins/support should call /admin/users/{userId}/match-history instead.
         * @summary [DEPRECATED] Always 401 — use GET /admin/users/{userId}/match-history
         * @param {string} version 
         * @param {number} id 
         * @param {number} offset 
         * @param {number} limit 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getUserMatchHistory(version: string, id: number, offset: number, limit: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getUserMatchHistory(version, id, offset, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        matchDetails(id: number, options?: RawAxiosRequestConfig): AxiosPromise<SingleWrapperTypedMatchResponse> {
            return localVarFp.matchDetails(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pendingMatchDetails(version: string, options?: RawAxiosRequestConfig): AxiosPromise<ArrayWrapperLong> {
            return localVarFp.pendingMatchDetails(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {MatchRequest} matchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveMatch(version: string, matchRequest: MatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<SingleWrapperLong> {
            return localVarFp.saveMatch(version, matchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {VerifiedMatchRequest} verifiedMatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveVerifiedMatch(version: string, verifiedMatchRequest: VerifiedMatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<Wrapper> {
            return localVarFp.saveVerifiedMatch(version, verifiedMatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {File} request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveVerifiedMatchCVS(version: string, request: File, options?: RawAxiosRequestConfig): AxiosPromise<Wrapper> {
            return localVarFp.saveVerifiedMatchCVS(version, request, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scoreFormats(version: string, options?: RawAxiosRequestConfig): AxiosPromise<ArrayWrapperScoreFormatResponse> {
            return localVarFp.scoreFormats(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {number} id 
         * @param {ShareMatchRequest} shareMatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareMatch(version: string, id: number, shareMatchRequest: ShareMatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<SingleWrapperPostResponse> {
            return localVarFp.shareMatch(version, id, shareMatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {number} offset 
         * @param {number} limit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userMatchHistory(version: string, offset: number, limit: number, options?: RawAxiosRequestConfig): AxiosPromise<SingleWrapperPageTypedMatchResponse> {
            return localVarFp.userMatchHistory(version, offset, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {MatchSearchRequest} matchSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userMatchHistoryByFilters(version: string, matchSearchRequest: MatchSearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<SingleWrapperPageTypedMatchResponse> {
            return localVarFp.userMatchHistoryByFilters(version, matchSearchRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MatchesApi - interface
 * @export
 * @interface MatchesApi
 */
export interface MatchesApiInterface {
    /**
     * Returns a sparse map keyed by obfuscated matchId. Matches with no active annotations are absent from the response. A match can carry annotations from multiple vendors — one entry per (match, clientKey) pair, with the obfuscated clientKeyId on each entry. Capped at 500 match IDs per request.
     * @summary Batch-fetch vendor annotations for a list of matches.
     * @param {string} version 
     * @param {BatchMatchAnnotationsRequest} batchMatchAnnotationsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApiInterface
     */
    batchAnnotations(version: string, batchMatchAnnotationsRequest: BatchMatchAnnotationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<object>;

    /**
     * 
     * @param {string} version 
     * @param {MatchConfirmRequest} matchConfirmRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApiInterface
     */
    confirmMatch(version: string, matchConfirmRequest: MatchConfirmRequest, options?: RawAxiosRequestConfig): AxiosPromise<Wrapper>;

    /**
     * 
     * @param {string} version 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApiInterface
     */
    deleteMatch1(version: string, id: number, options?: RawAxiosRequestConfig): AxiosPromise<Wrapper>;

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApiInterface
     */
    getDuprPerformanceData(version: string, options?: RawAxiosRequestConfig): AxiosPromise<ArrayWrapperObject>;

    /**
     * 
     * @param {string} version 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApiInterface
     */
    getDuprPerformanceDataUser(version: string, id: number, options?: RawAxiosRequestConfig): AxiosPromise<ArrayWrapperObject>;

    /**
     * 
     * @param {string} version 
     * @param {MatchForecastRequest} matchForecastRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApiInterface
     */
    getMatchExpectedScore(version: string, matchForecastRequest: MatchForecastRequest, options?: RawAxiosRequestConfig): AxiosPromise<MatchForecastResponse>;

    /**
     * 
     * @param {string} version 
     * @param {MatchForecastRequest} matchForecastRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApiInterface
     */
    getMatchForecast(version: string, matchForecastRequest: MatchForecastRequest, options?: RawAxiosRequestConfig): AxiosPromise<MatchForecastResponse>;

    /**
     * 
     * @param {string} version 
     * @param {MatchRatingSimulatorRequest} matchRatingSimulatorRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApiInterface
     */
    getMatchRatingSimulator(version: string, matchRatingSimulatorRequest: MatchRatingSimulatorRequest, options?: RawAxiosRequestConfig): AxiosPromise<object>;

    /**
     * Deprecated. Always returns 401 regardless of auth state. Originally surfaced for pre-signup claim flows but was never wired truly-public; admins/support should call /admin/users/{userId}/match-history instead.
     * @summary [DEPRECATED] Always 401 — use GET /admin/users/{userId}/match-history
     * @param {string} version 
     * @param {number} id 
     * @param {number} offset 
     * @param {number} limit 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof MatchesApiInterface
     */
    getUserMatchHistory(version: string, id: number, offset: number, limit: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApiInterface
     */
    matchDetails(id: number, options?: RawAxiosRequestConfig): AxiosPromise<SingleWrapperTypedMatchResponse>;

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApiInterface
     */
    pendingMatchDetails(version: string, options?: RawAxiosRequestConfig): AxiosPromise<ArrayWrapperLong>;

    /**
     * 
     * @param {string} version 
     * @param {MatchRequest} matchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApiInterface
     */
    saveMatch(version: string, matchRequest: MatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<SingleWrapperLong>;

    /**
     * 
     * @param {string} version 
     * @param {VerifiedMatchRequest} verifiedMatchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApiInterface
     */
    saveVerifiedMatch(version: string, verifiedMatchRequest: VerifiedMatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<Wrapper>;

    /**
     * 
     * @param {string} version 
     * @param {File} request 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApiInterface
     */
    saveVerifiedMatchCVS(version: string, request: File, options?: RawAxiosRequestConfig): AxiosPromise<Wrapper>;

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApiInterface
     */
    scoreFormats(version: string, options?: RawAxiosRequestConfig): AxiosPromise<ArrayWrapperScoreFormatResponse>;

    /**
     * 
     * @param {string} version 
     * @param {number} id 
     * @param {ShareMatchRequest} shareMatchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApiInterface
     */
    shareMatch(version: string, id: number, shareMatchRequest: ShareMatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<SingleWrapperPostResponse>;

    /**
     * 
     * @param {string} version 
     * @param {number} offset 
     * @param {number} limit 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApiInterface
     */
    userMatchHistory(version: string, offset: number, limit: number, options?: RawAxiosRequestConfig): AxiosPromise<SingleWrapperPageTypedMatchResponse>;

    /**
     * 
     * @param {string} version 
     * @param {MatchSearchRequest} matchSearchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApiInterface
     */
    userMatchHistoryByFilters(version: string, matchSearchRequest: MatchSearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<SingleWrapperPageTypedMatchResponse>;

}

/**
 * MatchesApi - object-oriented interface
 * @export
 * @class MatchesApi
 * @extends {BaseAPI}
 */
export class MatchesApi extends BaseAPI implements MatchesApiInterface {
    /**
     * Returns a sparse map keyed by obfuscated matchId. Matches with no active annotations are absent from the response. A match can carry annotations from multiple vendors — one entry per (match, clientKey) pair, with the obfuscated clientKeyId on each entry. Capped at 500 match IDs per request.
     * @summary Batch-fetch vendor annotations for a list of matches.
     * @param {string} version 
     * @param {BatchMatchAnnotationsRequest} batchMatchAnnotationsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApi
     */
    public batchAnnotations(version: string, batchMatchAnnotationsRequest: BatchMatchAnnotationsRequest, options?: RawAxiosRequestConfig) {
        return MatchesApiFp(this.configuration).batchAnnotations(version, batchMatchAnnotationsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {MatchConfirmRequest} matchConfirmRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApi
     */
    public confirmMatch(version: string, matchConfirmRequest: MatchConfirmRequest, options?: RawAxiosRequestConfig) {
        return MatchesApiFp(this.configuration).confirmMatch(version, matchConfirmRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApi
     */
    public deleteMatch1(version: string, id: number, options?: RawAxiosRequestConfig) {
        return MatchesApiFp(this.configuration).deleteMatch1(version, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApi
     */
    public getDuprPerformanceData(version: string, options?: RawAxiosRequestConfig) {
        return MatchesApiFp(this.configuration).getDuprPerformanceData(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApi
     */
    public getDuprPerformanceDataUser(version: string, id: number, options?: RawAxiosRequestConfig) {
        return MatchesApiFp(this.configuration).getDuprPerformanceDataUser(version, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {MatchForecastRequest} matchForecastRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApi
     */
    public getMatchExpectedScore(version: string, matchForecastRequest: MatchForecastRequest, options?: RawAxiosRequestConfig) {
        return MatchesApiFp(this.configuration).getMatchExpectedScore(version, matchForecastRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {MatchForecastRequest} matchForecastRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApi
     */
    public getMatchForecast(version: string, matchForecastRequest: MatchForecastRequest, options?: RawAxiosRequestConfig) {
        return MatchesApiFp(this.configuration).getMatchForecast(version, matchForecastRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {MatchRatingSimulatorRequest} matchRatingSimulatorRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApi
     */
    public getMatchRatingSimulator(version: string, matchRatingSimulatorRequest: MatchRatingSimulatorRequest, options?: RawAxiosRequestConfig) {
        return MatchesApiFp(this.configuration).getMatchRatingSimulator(version, matchRatingSimulatorRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated. Always returns 401 regardless of auth state. Originally surfaced for pre-signup claim flows but was never wired truly-public; admins/support should call /admin/users/{userId}/match-history instead.
     * @summary [DEPRECATED] Always 401 — use GET /admin/users/{userId}/match-history
     * @param {string} version 
     * @param {number} id 
     * @param {number} offset 
     * @param {number} limit 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof MatchesApi
     */
    public getUserMatchHistory(version: string, id: number, offset: number, limit: number, options?: RawAxiosRequestConfig) {
        return MatchesApiFp(this.configuration).getUserMatchHistory(version, id, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApi
     */
    public matchDetails(id: number, options?: RawAxiosRequestConfig) {
        return MatchesApiFp(this.configuration).matchDetails(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApi
     */
    public pendingMatchDetails(version: string, options?: RawAxiosRequestConfig) {
        return MatchesApiFp(this.configuration).pendingMatchDetails(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {MatchRequest} matchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApi
     */
    public saveMatch(version: string, matchRequest: MatchRequest, options?: RawAxiosRequestConfig) {
        return MatchesApiFp(this.configuration).saveMatch(version, matchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {VerifiedMatchRequest} verifiedMatchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApi
     */
    public saveVerifiedMatch(version: string, verifiedMatchRequest: VerifiedMatchRequest, options?: RawAxiosRequestConfig) {
        return MatchesApiFp(this.configuration).saveVerifiedMatch(version, verifiedMatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {File} request 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApi
     */
    public saveVerifiedMatchCVS(version: string, request: File, options?: RawAxiosRequestConfig) {
        return MatchesApiFp(this.configuration).saveVerifiedMatchCVS(version, request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApi
     */
    public scoreFormats(version: string, options?: RawAxiosRequestConfig) {
        return MatchesApiFp(this.configuration).scoreFormats(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {number} id 
     * @param {ShareMatchRequest} shareMatchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApi
     */
    public shareMatch(version: string, id: number, shareMatchRequest: ShareMatchRequest, options?: RawAxiosRequestConfig) {
        return MatchesApiFp(this.configuration).shareMatch(version, id, shareMatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {number} offset 
     * @param {number} limit 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApi
     */
    public userMatchHistory(version: string, offset: number, limit: number, options?: RawAxiosRequestConfig) {
        return MatchesApiFp(this.configuration).userMatchHistory(version, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {MatchSearchRequest} matchSearchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApi
     */
    public userMatchHistoryByFilters(version: string, matchSearchRequest: MatchSearchRequest, options?: RawAxiosRequestConfig) {
        return MatchesApiFp(this.configuration).userMatchHistoryByFilters(version, matchSearchRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

